// Mapeos uniformes para tipos de transporte
// Convierte valores UI/selectable a valores de BD

export const TRANSPORT_TYPE_UI_OPTIONS = {
  LIGHT: 'light',
  AUTO: 'auto',
  CAMIONETA: 'camioneta',
  COORDINATE: 'coordinar_vendedor',
  WALKING: 'walking',
} as const;

// Mapeo de valores UI a valores BD
// BD válidos: 'walking', 'bike', 'motorcycle', 'car', 'van'
export const TRANSPORT_TYPE_MAP: Record<string, string | null> = {
  // UI options → DB values
  'light': 'bike',           // light (moto/bici) → bike
  'motorcycle': 'motorcycle',
  'moto': 'motorcycle',
  'bike': 'bike',
  'bici': 'bike',
  'bicicleta': 'bike',
  
  'auto': 'car',             // auto → car
  'car': 'car',
  
  'camioneta': 'van',        // camioneta → van
  'van': 'van',
  'truck': 'van',
  
  'walking': 'walking',
  
  // Special cases
  'coordinar_vendedor': null,  // null = sin restricción de transporte
  
  // Legacy/fallbacks
  'motorcycle_legacy': 'motorcycle',
};

export const getDbTransportType = (uiValue: string | null | undefined): string | null => {
  if (!uiValue) return null;
  return TRANSPORT_TYPE_MAP[uiValue.toLowerCase()] ?? uiValue;
};

// Métodos auxiliares para filtrado
export const isTransportTypeCompatible = (
  requiredType: string | null | undefined,
  courierType: string | null | undefined
): boolean => {
  if (!requiredType) return true; // Sin restricción
  if (!courierType) return false;

  const required = requiredType.toLowerCase();
  const courier = courierType.toLowerCase();

  // Normalizar primero
  const normalizedRequired = getDbTransportType(required);
  const normalizedCourier = getDbTransportType(courier);

  if (normalizedRequired === 'bike') {
    // Light = motorcycle, bike, moto, bici
    return ['bike', 'motorcycle'].includes(normalizedCourier || '');
  }
  
  return normalizedRequired === normalizedCourier;
};

// Display labels
export const TRANSPORT_TYPE_LABELS: Record<string, string> = {
  'light': '🏍️ Moto/Bici',
  'bike': '🚲 Bici',
  'motorcycle': '🏍️ Moto',
  'auto': '🚗 Auto',
  'car': '🚗 Auto',
  'camioneta': '🚐 Camioneta',
  'van': '🚐 Camioneta',
  'walking': '🚶 A pie',
  'coordinar_vendedor': '🤝 Coordinar',
};
